module.exports = __webpack_public_path__ + "static/media/bleu3_optim_bis.80958d84.jpg";